import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To authenticate the CLI, you can call the `}<inlineCode parentName="p">{`login`}</inlineCode>{` command and follow the instructions:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`posthog-cli login
`}</code></pre>
    <p>{`If you are using the CLI in a CI/CD environment such as GitHub Actions, you can set environment variables to authenticate:`}</p>
    <div className="h-fit overflow-x-hidden">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Environment Variable`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Source`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`POSTHOG_CLI_HOST`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The PostHog host to connect to `}{`[default: https://us.posthog.com]`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "https://app.posthog.com/settings/project#variables"
              }}>{`Project settings`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`POSTHOG_CLI_ENV_ID`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`PostHog project ID`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "https://app.posthog.com/settings/project#variables"
              }}>{`Project settings`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`POSTHOG_CLI_TOKEN`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}><strong parentName="td">{`Personal API key`}</strong>{` with `}<inlineCode parentName="td">{`error tracking write`}</inlineCode>{` and `}<inlineCode parentName="td">{`organization read`}</inlineCode>{` scopes`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "https://app.posthog.com/settings/user-api-keys#variables"
              }}>{`API key settings`}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>{`You can also use the `}<inlineCode parentName="p">{`--host`}</inlineCode>{` option instead of the `}<inlineCode parentName="p">{`POSTHOG_CLI_HOST`}</inlineCode>{` environment variable to target a different PostHog instance or region. For EU users:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`posthog-cli --host https://eu.posthog.com [CMD]
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      